import { Carousel } from '@mantine/carousel';
import { Image } from '@mantine/core';
import { useState } from 'react';

import { PhotoTaggingModal, PhotoTagsOverlay } from 'src/Components/Community/PhotoTagging';

import styles from './MemoryModalPhotos.module.scss';
import { Props } from './MemoryModalPhotos.props';

/**
 * When viewing a memory, this component show all the photos in a carousel.
 */
const MemoryModalPhotos = ({ memory }: Props) => {
  const [taggingFileId, setTaggingFileId] = useState<string | null>(null);

  const photos = memory.files
    .map(file => {
      if (!file.previewLargeUrl) return null;

      return (
        <Carousel.Slide key={file.id} className={styles.slide}>
          <div className={styles.slideContent}>
            <Image src={file.previewLargeUrl ?? ''} className={styles.image} />
            <PhotoTagsOverlay
              storageFileId={file.id}
              onTagClick={() => setTaggingFileId(file.id)}
            />
          </div>
        </Carousel.Slide>
      );
    })
    .filter(v => !!v);

  return (
    <div className={styles.container}>
      <Carousel
        withControls={photos.length > 1}
        withIndicators={photos.length > 1}
        height="100%"
        loop
        style={{ flex: 1 }}
      >
        {photos}
      </Carousel>

      {taggingFileId && (
        <PhotoTaggingModal
          storageFileId={taggingFileId}
          opened={!!taggingFileId}
          onClose={() => setTaggingFileId(null)}
        />
      )}
    </div>
  );
};

export default MemoryModalPhotos;
